import React, {CSSProperties, memo, ReactNode} from 'react';
import './index.scss';
import { useChangeTheme } from '../../hooks/change-theme';

type Props = {
    children?: ReactNode;
    style?: CSSProperties;
};

export const Widget = memo(function Widget({children, style}: Props) {
    const {theme} = useChangeTheme()
    return (
        <div className={`widget-wrapper ${theme === 'rounded' ? 'widget-wrapper-options' : ''}`} style={style}>
            <div className="widget-content">
                {children}
            </div>
        </div>
    );
});
